import {Controller} from "stimulus"
import {
    TweenLite,
    // easing
    Linear,
    Power2,
} from "gsap/TweenLite"

import {
    TimelineLite,
} from "gsap/TimelineLite"

import EventEmitter from "../utils/EventEmitter";
import windowVisibility from "../utils/windowVisibility";
import 'hammerjs';

// TODO: continue slider
export default class extends Controller {

    static targets = [
        "slide",
        "bullets",
        "thumbs",
        "progressBar",
        "indicatorCurrent",
        "indicatorMax",
        "name",
        "swiper"// for events
    ]

    initialize() {

        this.prevIndex = false
        this.currentIndex = 0
        this.timesClicked = 0

        this.timer = false;
        this.currentDirection = "next"

        this.windowIsActive = true

        this.windowIsActive = windowVisibility(); // gives current state

        this.initTimer()

        this.setImageW()

        window.addEventListener("resize", () => this.setImageW())

        EventEmitter.on(`slider-index-changed-${this.data.get("name")}`, (e) => this.onSliderIndexChanged(e))

        windowVisibility(() => {
            this.windowIsActive = windowVisibility()
        });

        // Hammer swipe
        this.initSwipeEvents()

        this.setIndicatorMax()

        if (this.$bullets) {
            this.$bullets.forEach(($bullet, index) => {
                $bullet.addEventListener("click", e => this.goTo(e, index))
            })
        }

        if (this.$thumbs) {
            this.$thumbs.forEach(($thumb, index) => {
                $thumb.addEventListener("click", e => this.goTo(e, index))
            })
        }

        this.makeItReady()

    }

    initSwipeEvents(){
        if ( Hammer && this.hasSwiperTarget ) {

            // create a manager for that element
            const mc = new Hammer.Manager(this.swiperTarget)

            // create a recognizer
            const Pan = new Hammer.Pan()

            // add the recognizer
            mc.add(Pan)

            mc.on('panend', e => {
                if (this.currentDirection === "left") {
                    this.prev()
                } else if (this.currentDirection === "right") {
                    this.next()
                }
            })

            mc.on('panleft', e => {
                this.currentDirection = "right"
            })

            mc.on('panright', e => {
                this.currentDirection = "left"
            })

        }
    }

    makeItReady() {
        this.element.classList.remove("is-not-ready")
    }

    setIndicatorMax() {
        if (!this.hasIndicatorMaxTarget) {
            return
        }
        let count = this.$slideItems.length
        count = ('0' + count).slice(-2) // add 0 to start
        this.indicatorMaxTarget.innerHTML = count
    }

    setIndicator() {
        if (!this.hasIndicatorCurrentTarget) {
            return
        }
        let count = this.currentIndex + 1
        count = ('0' + count).slice(-2) // add 0 to start
        this.indicatorCurrentTarget.innerHTML = count
    }

    /**
     * In second in the data attribute
     * @returns {number}
     */
    get timerDuration() {
        let value = this.data.get("timerDuration")
        value = value ? parseFloat(value) * 1000 : 5000
        this.element.style.setProperty('--timer-duration', `${value}ms`);
        return value
    }

    get autoStartAt() {
        const value = this.data.get("autoStartAt")
        return value ? parseFloat(value) * 1000 : false
    }

    initTimer() {

        /**
         * Timer for progressbar
         */
        if (this.hasProgressBar && this.isAuto) {
            /*const timer = setTimeout(() => {
                console.log("Add active class")
                //this.progressBarTarget.classList.add("is-active")
                clearTimeout(timer)
            }, 10)*/
        }

        if (this.isAuto) {

            if (this.autoStartAt && this.timesClicked === 0) {

                this.timerStart = setTimeout(() => {

                    if (this.currentDirection === "next") {
                        this.next()
                    } else {
                        this.prev()
                    }

                    this.timer = setInterval(() => {

                        if (!this.windowIsActive) {
                            console.log("window is not active")
                            return;
                        }

                        if (this.currentDirection === "next") {
                            this.next()
                        } else {
                            this.prev()
                        }

                        this.resetTimer()
                        this.initTimer()

                    }, this.timerDuration)

                    clearTimeout(this.timerStart)

                }, this.autoStartAt)

            } else {

                TweenLite.fromTo(this.progressBarTarget, this.timerDuration / 1000, {"--progress": "0", ease: Linear.easeNone}, {"--progress": "1", ease: Linear.easeNone} )

                this.timer = setInterval(() => {

                    if (!this.windowIsActive) {
                        console.log("window is not active")
                        return;
                    }

                    if (this.currentDirection === "next") {
                        this.next()
                    } else {
                        this.prev()
                    }

                    this.resetTimer()

                    this.initTimer()

                }, this.timerDuration)

            }

        }

    }

    resetTimer() {
        if (!this.windowIsActive) {
            console.log("window is not active")
            return;
        }
        if (this.hasProgressBar) {
            //this.progressBarTarget.classList.remove("is-active")
        }
        clearInterval(this.timer)
        this.timer = false
    }

    onSliderIndexChanged(e) {
        const detail = e.detail
        const index = parseInt(detail.index)
        if (index === this.currentIndex) {
            return;
        }
        if ( isNaN(index) ) {
            console.log("onSliderIndexChanged", index, "isNaN")
        }
        this.currentIndex = isNaN(index) ? 0 : index
        const $nextSlide = this.$slideItems[this.currentIndex]
        console.log("$nextSlide", $nextSlide)
        const $nextSlideImg = $nextSlide.querySelector("img")
        this.timesClicked++
        TweenLite.set($nextSlideImg, {scale: 1})
        TweenLite.set($nextSlide, {width: "100%"})
        TweenLite.set($nextSlide, {zIndex: 2 * this.timesClicked})
        if (this.$bullets.length) {
            this.bulletsAnimation()
        }
        if (this.$thumbs.length) {
            this.thumbsAnimation()
        }
    }

    next(e) {

        if (e) {
            e.preventDefault()
        }

        console.table("go to next", this.currentIndex, this.count)

        if (this.currentIndex >= this.count - 1) {
            this.currentIndex = 0
            this.prevIndex = this.count - 1
        } else {
            this.prevIndex = this.currentIndex * 1
            this.currentIndex++
        }


        this.timesClicked++
        this.setIndicator()
        this.animate()

        if (e) {
            this.resetTimer()
            this.initTimer()
        }

    }

    goTo(e, currentIndex) {

        this.resetTimer()
        this.initTimer()

        if (e) {
            e.preventDefault()
        }

        const $el = e.currentTarget

        // No current index provided via function, get it from button
        if (currentIndex === undefined) {
            currentIndex = parseInt($el.dataset.index)
        }

        const $children = [...$el.parentElement.children]

        $children.forEach($child => $child.classList.remove("is-active"))

        $el.classList.toggle("is-active")

        if (this.currentIndex === currentIndex) {
            return false;
        }

        this.prevIndex = this.currentIndex * 1 // previous currentIndex
        this.currentIndex = currentIndex

        this.timesClicked++
        this.setIndicator()
        this.animate(e)

    }

    prev(e) {

        if (e) {
            e.preventDefault()
        }

        if (this.currentIndex === 0) {
            this.currentIndex = this.count - 1
            this.prevIndex = 0
        } else {
            this.prevIndex = this.currentIndex * 1
            this.currentIndex--
        }
        this.timesClicked++
        this.setIndicator()
        this.animate()

        if (e) {
            this.resetTimer()
            this.initTimer()
        }

    }

    setImageW() {
        // TODO: continue this
        const $items = this.$slideItems
        if ($items.length) {
            $items.forEach($item => {
                const $img = $item.querySelector("img")
                $img.dataset.width = $items[0].clientWidth.toString()
                TweenLite.set($img, {width: `${$items[0].clientWidth}px`})
            })
        }
    }

    photoAnimation() {
        const tl = new TimelineLite()
        const $nextSlide = this.$slideItems[this.currentIndex]
        console.log("photo animation", $nextSlide)
        const $nextSlideImg = $nextSlide.querySelector("img")
        tl.set($nextSlide, {width: "0%"})
        tl.set($nextSlideImg, {scale: 1.2})
        tl.set($nextSlide, {zIndex: 2 * this.timesClicked})
        tl.add("now")
        tl.to($nextSlideImg, this.nextImgAnimDuration, {scale: 1, ease: Power2.easeOut}, "now")
        tl.to($nextSlide, this.currentImgAnimDuration, {width: "100%", ease: Power2.easeInOut}, "now")
        return tl
    }

    bulletsAnimation() {
        const $nextBullet = this.$bullets[this.currentIndex]
        const tl = new TimelineLite()
        tl.set(this.$bullets, {className: "-=is-active"})
        tl.set($nextBullet, {className: "+=is-active"})
        return tl
    }

    thumbsAnimation() {
        const $nextThumb = this.$thumbs[this.currentIndex]
        const tl = new TimelineLite()
        tl.set(this.$thumbs, {className: "-=is-active"})
        tl.set($nextThumb, {className: "+=is-active"})
        return tl
    }

    animate(e) {
        const tl = new TimelineLite({})
        tl.add("start")
        if (this.$bullets.length) {
            tl.add(this.bulletsAnimation(), "start")
        }
        if (this.$thumbs.length) {
            tl.add(this.thumbsAnimation(), "start")
        }
        tl.add(this.photoAnimation(), "start")
    }

    get currentImgAnimDuration() {
        const value = this.data.get("currentImgAnimDuration")
        return value ? parseFloat(value) : 0.7
    }

    get nextImgAnimDuration() {
        const value = this.data.get("nextImgAnimDuration")
        return value ? parseFloat(value) : this.currentImgAnimDuration * 3
    }

    get hasProgressBar() {
        return this.hasProgressBarTarget
    }

    get $slideItems() {
        return this.slideTargets
    }

    get count() {
        return this.$slideItems.length
    }

    get $container() {
        return this.hasContainerTarget ? this.containerTarget : this.element
    }

    get $bullets() {
        return this.bulletsTargets
    }

    get $thumbs() {
        return this.thumbsTargets
    }

    get isAuto() {
        return parseInt(this.data.get("isAuto"))
    }

}